import { fetchRecommendedItemIfNeeded, getSortedRecommendedItemIdsFromState } from '@/redux/modules/recommendedItem';
import {
    fetchSavedSearchesIfNeeded,
    fetchSavedSearchItemsIfNeeded,
    getSavedSearchItemIds,
    hasSavedSearchesSelector,
} from '@/redux/modules/savedSearch';
import { fetchUpcomingItemsIfNeeded, getUpcomingItemIds } from '@/redux/modules/upcomingItems';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchHomeDataIfNeeded } from '@/redux/modules/home';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';
import { fetchSellerUpcomingCatalogsIfNeeded } from '@/redux/modules/sellerUpcomingCatalogs';
import { fetchUpcomingCatalogsIfNeeded } from '@/redux/modules/upcomingCatalogs';
import { getFollowedSellerIds } from '@/redux/modules/followSeller';
import { isUserLoggedIn } from '@/redux/modules/user';

const MAX_TODAY_AUCTIONS = 20;

export default ({ store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const state = getState();
    const hasSavedSearches = hasSavedSearchesSelector(state);
    const followedSellerIds = getFollowedSellerIds(state);
    return Promise.all([
        dispatch(fetchHomeDataIfNeeded()),
        dispatch(fetchUpcomingItemsIfNeeded()),
        dispatch(fetchUpcomingCatalogsIfNeeded(MAX_TODAY_AUCTIONS, true)),
        dispatch(fetchSavedSearchesIfNeeded()),
        dispatch(fetchSavedSearchItemsIfNeeded(hasSavedSearches)),
        dispatch(fetchRecommendedItemIfNeeded(false)),
        ...followedSellerIds.map((sellerId) => dispatch(fetchSellerUpcomingCatalogsIfNeeded(sellerId))),
    ]).then(() => {
        const newState = getState();
        const isLoggedIn = isUserLoggedIn(newState);
        const promises = [];

        if (isLoggedIn) {
            const upcomingItemIds = getUpcomingItemIds(newState);
            const savedSearchItemIds = getSavedSearchItemIds(newState);
            const recommendedItemIds = getSortedRecommendedItemIdsFromState(newState, 12);
            promises.push(dispatch(fetchItemCardModelsIfNeeded(upcomingItemIds, 'COMING-UP-Carousel')));
            promises.push(dispatch(fetchItemCardModelsIfNeeded(savedSearchItemIds, 'FOLLOWED-SEARCH-Carousel')));
            promises.push(dispatch(fetchItemCardModelsIfNeeded(recommendedItemIds, 'RECOMMENDED-ITEM-Carousel')));
        }

        return Promise.all(promises);
    });
};
